import { createActions } from "redux-actions";

export const { setCompany, setCompanies, updateCompanyName } = createActions({
  SET_COMPANY: ({ companyId, companyName, usersRights }) => ({
    companyId,
    companyName,
    usersRights,
  }),
  SET_COMPANIES: ({ items }) => ({ items }),
  UPDATE_COMPANY_NAME: ({ companyId, newName }) => ({ companyId, newName }),
});
